/**
 * Container Type Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {string}
 */
window.containerTypeFormatter = function(value, row) {
    let html = '';
    switch (row.container_type) {
        case TYPE_REEFER:
            html += __('Reefer');
            break;
        case TYPE_DRY_CONTAINER:
            html += __('Dry Container');
            break;
    }
    return html;
};
